import { render, staticRenderFns } from "./PlayerIo.vue?vue&type=template&id=0b90a9d0&"
import script from "./PlayerIo.vue?vue&type=script&lang=js&"
export * from "./PlayerIo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports